import React from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import { Button } from "components/bootstrap";
import { DataTable } from "components/common";
const getNotificationPlugin = (type) => {
  if (type === void 0) {
    return void 0;
  }
  return PluginStore.exports("eventNotificationTypes").find((n) => n.type === type);
};
class NotificationList extends React.Component {
  constructor() {
    super(...arguments);
    this.handleRemoveClick = (notificationId) => () => {
      const { onRemoveNotificationClick } = this.props;
      onRemoveNotificationClick(notificationId);
    };
    this.notificationFormatter = (notification) => {
      if (notification.missing) {
        return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { colSpan: 2 }, "Could not find information for Notification ", /* @__PURE__ */ React.createElement("em", null, notification.title)), /* @__PURE__ */ React.createElement("td", { className: "actions" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xsmall", onClick: this.handleRemoveClick(notification.title) }, "Delete")));
      }
      const plugin = getNotificationPlugin(notification.config.type);
      return /* @__PURE__ */ React.createElement("tr", { key: notification.id }, /* @__PURE__ */ React.createElement("td", null, notification.title), /* @__PURE__ */ React.createElement("td", null, (plugin == null ? void 0 : plugin.displayName) || notification.config.type), /* @__PURE__ */ React.createElement("td", { className: "actions" }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", bsSize: "xsmall", onClick: this.handleRemoveClick(notification.id) }, "Delete")));
    };
  }
  render() {
    const { eventDefinition, notifications, onAddNotificationClick } = this.props;
    const definitionNotifications = eventDefinition.notifications.map(
      (edn) => notifications.find((n) => n.id === edn.notification_id) || {
        title: edn.notification_id,
        missing: true
      }
    );
    const addNotificationButton = /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onAddNotificationClick }, "Add notification");
    if (definitionNotifications.length === 0) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, "This Event is not configured to trigger any Notifications yet."), addNotificationButton);
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      DataTable,
      {
        id: "event-definition-notifications",
        className: "table-striped table-hover",
        headers: ["Notification", "Type", "Actions"],
        sortByKey: "title",
        rows: definitionNotifications,
        dataRowFormatter: this.notificationFormatter,
        filterKeys: []
      }
    ), addNotificationButton);
  }
}
export default NotificationList;
